// WonderNetwork server locations for link generation
export const WONDERNETWORK_LOCATIONS = [
  { name: "Accra", location: "Accra", country: "Ghana" },
  { name: "Adelaide", location: "Adelaide", country: "Australia" },
  { name: "Albany", location: "Latham", country: "United States" },
  { name: "Alblasserdam", location: "Alblasserdam", country: "Netherlands" },
  { name: "Albuquerque", location: "Albuquerque", country: "United States" },
  { name: "Algiers", location: "Algiers", country: "Algeria" },
  { name: "Almaty", location: "Almaty", country: "Kazakhstan" },
  { name: "Amsterdam", location: "Haarlemmermeer", country: "Netherlands" },
  { name: "Ankara", location: "Ankara", country: "Turkey" },
  { name: "Antwerp", location: "Antwerp", country: "Belgium" },
  { name: "Arezzo", location: "Arezzo", country: "Italy" },
  { name: "Asheville", location: "Asheville", country: "United States" },
  { name: "Asuncion", location: "Asuncion", country: "Paraguay" },
  { name: "Athens", location: "Athens", country: "Greece" },
  { name: "Atlanta", location: "Atlanta", country: "United States" },
  { name: "Auckland", location: "Auckland", country: "New Zealand" },
  { name: "Austin", location: "Austin", country: "United States" },
  { name: "Baku", location: "Baku", country: "Azerbaijan" },
  { name: "Baltimore", location: "Baltimore", country: "United States" },
  { name: "Bangalore", location: "Bangalore", country: "India" },
  { name: "Bangkok", location: "Bangkok", country: "Thailand" },
  { name: "Barcelona", location: "Barcelona", country: "Spain" },
  { name: "Basel", location: "Basel", country: "Switzerland" },
  { name: "Beirut", location: "Beirut", country: "Lebanon" },
  { name: "Belfast", location: "Belfast", country: "United Kingdom" },
  { name: "Belgrade", location: "Belgrade", country: "Serbia" },
  { name: "Bergen", location: "Bergen", country: "Norway" },
  { name: "Berlin", location: "Berlin", country: "Germany" },
  { name: "Bern", location: "Bern", country: "Switzerland" },
  { name: "Billings", location: "Billings", country: "United States" },
  { name: "Bishkek", location: "Bishkek", country: "Kyrgyzstan" },
  { name: "Bogota", location: "Bogota", country: "Colombia" },
  { name: "Boston", location: "Somerville", country: "United States" },
  { name: "Brasilia", location: "Brasilia", country: "Brazil" },
  { name: "Bratislava", location: "Bratislava", country: "Slovakia" },
  { name: "Brazzaville", location: "Brazzaville", country: "Congo" },
  { name: "Brisbane", location: "Brisbane", country: "Australia" },
  { name: "Bristol", location: "Bristol", country: "United Kingdom" },
  { name: "Brno", location: "Brno", country: "Czech Republic" },
  { name: "Brunswick", location: "Brunswick", country: "United States" },
  { name: "Brussels", location: "Brussels", country: "Belgium" },
  { name: "Bucharest", location: "Bucharest", country: "Romania" },
  { name: "Budapest", location: "Budapest", country: "Hungary" },
  { name: "Buenos Aires", location: "Buenos Aires", country: "Argentina" },
  { name: "Buffalo", location: "Buffalo", country: "United States" },
  { name: "Bursa", location: "Bursa", country: "Turkey" },
  { name: "Cairo", location: "10th of Ramadan City", country: "Egypt" },
  { name: "Calgary", location: "Calgary", country: "Canada" },
  { name: "Canberra", location: "Canberra", country: "Australia" },
  { name: "Cape Town", location: "Cape Town", country: "South Africa" },
  { name: "Caracas", location: "Caracas", country: "Venezuela" },
  { name: "Cardiff", location: "Cardiff", country: "United Kingdom" },
  { name: "Carlow", location: "Carlow", country: "Ireland" },
  { name: "Charlotte", location: "Charlotte", country: "United States" },
  { name: "Cheltenham", location: "Cheltenham", country: "United Kingdom" },
  { name: "Chennai", location: "Chennai", country: "India" },
  { name: "Cheyenne", location: "Cheyenne", country: "United States" },
  { name: "Chicago", location: "Chicago", country: "United States" },
  { name: "Chisinau", location: "Chisinau", country: "Moldova" },
  { name: "Christchurch", location: "Christchurch", country: "New Zealand" },
  { name: "Cincinnati", location: "Cincinnati", country: "United States" },
  { name: "Clark", location: "Clark", country: "Philippines" },
  { name: "Cleveland", location: "Mentor", country: "United States" },
  { name: "Cluj Napoca", location: "Cluj Napoca", country: "Romania" },
  { name: "Colorado Springs", location: "Colorado Springs", country: "United States" },
  { name: "Columbus", location: "Columbus", country: "United States" },
  { name: "Copenhagen", location: "Copenhagen", country: "Denmark" },
  { name: "Coventry", location: "Coventry", country: "United Kingdom" },
  { name: "Cromwell", location: "Cromwell", country: "United States" },
  { name: "Dagupan", location: "Dagupan", country: "Philippines" },
  { name: "Dallas", location: "Dallas", country: "United States" },
  { name: "Dar es Salaam", location: "Dar es Salaam", country: "Tanzania" },
  { name: "Denver", location: "Denver", country: "United States" },
  { name: "Des Moines", location: "Des Moines", country: "United States" },
  { name: "Detroit", location: "Detroit", country: "United States" },
  { name: "Dhaka", location: "Dhaka", country: "Bangladesh" },
  { name: "Douglas", location: "Douglas", country: "Isle of Man" },
  { name: "Dronten", location: "Dronten", country: "Netherlands" },
  { name: "Dubai", location: "Dubai", country: "United Arab Emirates" },
  { name: "Dublin", location: "Dublin", country: "Ireland" },
  { name: "Dusseldorf", location: "Dusseldorf", country: "Germany" },
  { name: "Edinburgh", location: "Edinburgh", country: "United Kingdom" },
  { name: "Edmonton", location: "St Albert", country: "Canada" },
  { name: "Eindhoven", location: "Eindhoven", country: "Netherlands" },
  { name: "Falkenberg", location: "Falkenberg", country: "Sweden" },
  { name: "Falkenstein", location: "Falkenstein", country: "Germany" },
  { name: "Fez", location: "Fez", country: "Morocco" },
  { name: "Frankfurt", location: "Frankfurt", country: "Germany" },
  { name: "Fremont", location: "Fremont", country: "United States" },
  { name: "Frosinone", location: "Frosinone", country: "Italy" },
  { name: "Gdansk", location: "Gdansk", country: "Poland" },
  { name: "Geneva", location: "Vernier", country: "Switzerland" },
  { name: "Gosport", location: "Gosport", country: "United Kingdom" },
  { name: "Graz", location: "Graz", country: "Austria" },
  { name: "Green Bay", location: "Green Bay", country: "United States" },
  { name: "Groningen", location: "Groningen", country: "Netherlands" },
  { name: "Guadalajara", location: "Guadalajara", country: "Mexico" },
  { name: "Guatemala", location: "Guatemala City", country: "Guatemala" },
  { name: "Halifax", location: "Halifax", country: "Canada" },
  { name: "Hamburg", location: "Hamburg", country: "Germany" },
  { name: "Hangzhou", location: "Hangzhou", country: "China" },
  { name: "Hanoi", location: "Hanoi", country: "Vietnam" },
  { name: "Helsinki", location: "Espoo", country: "Finland" },
  { name: "Heredia", location: "San Jose", country: "Costa Rica" },
  { name: "Ho Chi Minh City", location: "Ho Chi Minh City", country: "Vietnam" },
  { name: "Hong Kong", location: "Hong Kong", country: "Hong Kong" },
  { name: "Honolulu", location: "Honolulu", country: "United States" },
  { name: "Houston", location: "Houston", country: "United States" },
  { name: "Hyderabad", location: "Hyderabad", country: "India" },
  { name: "Iasi", location: "Iasi", country: "Romania" },
  { name: "Indianapolis", location: "Indianapolis", country: "United States" },
  { name: "Indore", location: "Indore", country: "India" },
  { name: "Istanbul", location: "Istanbul", country: "Turkey" },
  { name: "Izmir", location: "Izmir", country: "Turkey" },
  { name: "Jackson", location: "Jackson", country: "United States" },
  { name: "Jacksonville", location: "Jacksonville", country: "United States" },
  { name: "Jakarta", location: "Jakarta", country: "Indonesia" },
  { name: "Jerusalem", location: "Jerusalem", country: "Israel" },
  { name: "Joao Pessoa", location: "Patos", country: "Brazil" },
  { name: "Johannesburg", location: "Johannesburg", country: "South Africa" },
  { name: "Kampala", location: "Kampala", country: "Uganda" },
  { name: "Kansas City", location: "Kansas City", country: "United States" },
  { name: "Karachi", location: "Karachi", country: "Pakistan" },
  { name: "Karaganda", location: "Karaganda", country: "Kazakhstan" },
  { name: "Kazan", location: "Kazan", country: "Russia" },
  { name: "Khabarovsk", location: "Khabarovsk", country: "Russia" },
  { name: "Kharkiv", location: "Kharkiv", country: "Ukraine" },
  { name: "Knoxville", location: "Knoxville", country: "United States" },
  { name: "Koto", location: "Koto", country: "Japan" },
  { name: "Ktis", location: "Ktis", country: "Czech Republic" },
  { name: "Kuala Lumpur", location: "Kuala Lumpur", country: "Malaysia" },
  { name: "Kyiv", location: "Kyiv", country: "Ukraine" },
  { name: "La Paz", location: "La Paz", country: "Bolivia" },
  { name: "Lagos", location: "Lagos", country: "Nigeria" },
  { name: "Lahore", location: "Lahore", country: "Pakistan" },
  { name: "Lansing", location: "Lansing", country: "United States" },
  { name: "Las Vegas", location: "Las Vegas", country: "United States" },
  { name: "Lausanne", location: "Lausanne", country: "Switzerland" },
  { name: "Liege", location: "Liege", country: "Belgium" },
  { name: "Lima", location: "Lima", country: "Peru" },
  { name: "Limassol", location: "Limassol", country: "Cyprus" },
  { name: "Lincoln", location: "Lincoln", country: "United States" },
  { name: "Lisbon", location: "Lisbon", country: "Portugal" },
  { name: "Ljubljana", location: "Ljubljana", country: "Slovenia" },
  { name: "London", location: "London", country: "United Kingdom" },
  { name: "Los Angeles", location: "Los Angeles", country: "United States" },
  { name: "Lugano", location: "Lugano", country: "Switzerland" },
  { name: "Luxembourg", location: "Steinsel", country: "Luxembourg" },
  { name: "Lyon", location: "Lyon", country: "France" },
  { name: "Madrid", location: "Madrid", country: "Spain" },
  { name: "Maidstone", location: "Maidstone", country: "United Kingdom" },
  { name: "Manchester", location: "Manchester", country: "United Kingdom" },
  { name: "Manhattan", location: "New York City", country: "United States" },
  { name: "Manila", location: "Manila", country: "Philippines" },
  { name: "Marseille", location: "Marseille", country: "France" },
  { name: "Medellin", location: "Medellin", country: "Colombia" },
  { name: "Melbourne", location: "Melbourne", country: "Australia" },
  { name: "Memphis", location: "Memphis", country: "United States" },
  { name: "Mexico City", location: "Mexico City", country: "Mexico" },
  { name: "Miami", location: "Miami", country: "United States" },
  { name: "Milan", location: "Milan", country: "Italy" },
  { name: "Milwaukee", location: "Milwaukee", country: "United States" },
  { name: "Minneapolis", location: "Minneapolis", country: "United States" },
  { name: "Montevideo", location: "Pando", country: "Uruguay" },
  { name: "Monticello", location: "Monticello", country: "United States" },
  { name: "Montreal", location: "Laval", country: "Canada" },
  { name: "Moscow", location: "Moscow", country: "Russia" },
  { name: "Mumbai", location: "Mumbai", country: "India" },
  { name: "Munich", location: "Munich", country: "Germany" },
  { name: "Muscat", location: "Muscat", country: "Oman" },
  { name: "Nairobi", location: "Nairobi", country: "Kenya" },
  { name: "New Delhi", location: "New Delhi", country: "India" },
  { name: "New Orleans", location: "New Orleans", country: "United States" },
  { name: "New York", location: "Garden City", country: "United States" },
  { name: "Newcastle", location: "Newcastle", country: "United Kingdom" },
  { name: "Novi Travnik", location: "Novi Travnik", country: "Bosnia and Herzegovina" },
  { name: "Novosibirsk", location: "Novosibirsk", country: "Russia" },
  { name: "Nuremberg", location: "Nuremberg", country: "Germany" },
  { name: "Orlando", location: "Orlando", country: "United States" },
  { name: "Osaka", location: "Osaka", country: "Japan" },
  { name: "Oslo", location: "Oslo", country: "Norway" },
  { name: "Ottawa", location: "Ottawa", country: "Canada" },
  { name: "Oulu", location: "Oulu", country: "Finland" },
  { name: "Palermo", location: "Palermo", country: "Italy" },
  { name: "Panama", location: "Panama City", country: "Panama" },
  { name: "Paris", location: "Paris", country: "France" },
  { name: "Perth", location: "Perth", country: "Australia" },
  { name: "Philadelphia", location: "Philadelphia", country: "United States" },
  { name: "Phnom Penh", location: "Phnom Penh", country: "Cambodia" },
  { name: "Phoenix", location: "Phoenix", country: "United States" },
  { name: "Piscataway", location: "Piscataway", country: "United States" },
  { name: "Pittsburgh", location: "Pittsburgh", country: "United States" },
  { name: "Portland", location: "Portland", country: "United States" },
  { name: "Prague", location: "Prague", country: "Czech Republic" },
  { name: "Pune", location: "Pune", country: "India" },
  { name: "Quebec City", location: "Quebec City", country: "Canada" },
  { name: "Quito", location: "Quito", country: "Ecuador" },
  { name: "Raleigh", location: "Cary", country: "United States" },
  { name: "Redding", location: "Redding", country: "United States" },
  { name: "Reykjavik", location: "Hafnarfjordur", country: "Iceland" },
  { name: "Riga", location: "Riga", country: "Latvia" },
  { name: "Riyadh", location: "Riyadh", country: "Saudi Arabia" },
  { name: "Rome", location: "Rome", country: "Italy" },
  { name: "Roseburg", location: "Roseburg", country: "United States" },
  { name: "Roubaix", location: "Roubaix", country: "France" },
  { name: "Sacramento", location: "Sacramento", country: "United States" },
  { name: "Salem", location: "Salem", country: "United States" },
  { name: "Salt Lake City", location: "Salt Lake City", country: "United States" },
  { name: "San Antonio", location: "San Antonio", country: "United States" },
  { name: "San Diego", location: "San Diego", country: "United States" },
  { name: "San Francisco", location: "San Francisco", country: "United States" },
  { name: "San Jose", location: "San Jose", country: "United States" },
  { name: "San Juan", location: "San Juan", country: "Puerto Rico" },
  { name: "Santiago", location: "Santiago", country: "Chile" },
  { name: "Sao Paulo", location: "Sao Paulo", country: "Brazil" },
  { name: "Saskatoon", location: "Saskatoon", country: "Canada" },
  { name: "Savannah", location: "Savannah", country: "United States" },
  { name: "Scranton", location: "Scranton", country: "United States" },
  { name: "Seattle", location: "Seattle", country: "United States" },
  { name: "Secaucus", location: "Secaucus", country: "United States" },
  { name: "Seoul", location: "Seoul", country: "South Korea" },
  { name: "Seville", location: "Seville", country: "Spain" },
  { name: "Shanghai", location: "Shanghai", country: "China" },
  { name: "Shenzhen", location: "Shenzhen", country: "China" },
  { name: "Siauliai", location: "Siauliai", country: "Lithuania" },
  { name: "Singapore", location: "Singapore", country: "Singapore" },
  { name: "Skopje", location: "Skopje", country: "North Macedonia" },
  { name: "Sofia", location: "Sofia", country: "Bulgaria" },
  { name: "Spokane", location: "Liberty Lake", country: "United States" },
  { name: "St Louis", location: "St Louis", country: "United States" },
  { name: "St Petersburg", location: "St Petersburg", country: "Russia" },
  { name: "Stockholm", location: "Stockholm", country: "Sweden" },
  { name: "Strasbourg", location: "Strasbourg", country: "France" },
  { name: "Sydney", location: "Sydney", country: "Australia" },
  { name: "Syracuse", location: "Syracuse", country: "United States" },
  { name: "Taipei", location: "Taipei", country: "Taiwan" },
  { name: "Tallinn", location: "Tallinn", country: "Estonia" },
  { name: "Tampa", location: "Tampa", country: "United States" },
  { name: "Tashkent", location: "Tashkent", country: "Uzbekistan" },
  { name: "Tbilisi", location: "Tbilisi", country: "Georgia" },
  { name: "Tel Aviv", location: "Tel Aviv", country: "Israel" },
  { name: "The Hague", location: "The Hague", country: "Netherlands" },
  { name: "Thessaloniki", location: "Thessaloniki", country: "Greece" },
  { name: "Tirana", location: "Tirana", country: "Albania" },
  { name: "Tokyo", location: "Tokyo", country: "Japan" },
  { name: "Toledo", location: "Toledo", country: "United States" },
  { name: "Toronto", location: "Toronto", country: "Canada" },
  { name: "Tunis", location: "Tunis", country: "Tunisia" },
  { name: "Valencia", location: "Valencia", country: "Spain" },
  { name: "Valletta", location: "Valletta", country: "Malta" },
  { name: "Vancouver", location: "Vancouver", country: "Canada" },
  { name: "Varna", location: "Varna", country: "Bulgaria" },
  { name: "Venice", location: "Noventa di Piave", country: "Italy" },
  { name: "Vienna", location: "Vienna", country: "Austria" },
  { name: "Vientiane", location: "Vientiane", country: "Laos" },
  { name: "Vilnius", location: "Vilnius", country: "Lithuania" },
  { name: "Warsaw", location: "Warsaw", country: "Poland" },
  { name: "Washington", location: "Herndon", country: "United States" },
  { name: "Wellington", location: "Wellington", country: "New Zealand" },
  { name: "Westpoort", location: "Westpoort", country: "Netherlands" },
  { name: "Wilmington", location: "Wilmington", country: "United States" },
  { name: "Winnipeg", location: "Winnipeg", country: "Canada" },
  { name: "Yangon", location: "Yangon", country: "Myanmar" },
  { name: "Yerevan", location: "Yerevan", country: "Armenia" },
  { name: "Zagreb", location: "Zagreb", country: "Croatia" },
  { name: "Zhangjiakou", location: "Zhangjiakou", country: "China" },
  { name: "Zurich", location: "Zurich", country: "Switzerland" }
];

// Helper function to find WonderNetwork location by city name
export function findWonderNetworkLocation(cityName: string) {
  if (!cityName) return null;

  // Clean up the search term - remove state codes, country names, extra whitespace
  let searchTerm = cityName.toLowerCase().trim();

  // Remove common patterns like ", CA", ", NY", ", USA", etc.
  searchTerm = searchTerm
    .replace(/,\s*[a-z]{2}$/i, '') // Remove ", XX" state codes at end
    .replace(/,\s*usa$/i, '')      // Remove ", USA"
    .replace(/,\s*us$/i, '')       // Remove ", US"
    .replace(/,\s*united states$/i, '') // Remove ", United States"
    .trim();

  // Direct name match
  const directMatch = WONDERNETWORK_LOCATIONS.find(
    loc => loc.name.toLowerCase() === searchTerm
  );

  if (directMatch) {
    return {
      serverName: directMatch.name.toLowerCase().replace(/\s+/g, '-'),
      displayName: directMatch.name,
      country: directMatch.country
    };
  }

  // Location match
  const locationMatch = WONDERNETWORK_LOCATIONS.find(
    loc => loc.location.toLowerCase() === searchTerm
  );

  if (locationMatch) {
    return {
      serverName: locationMatch.name.toLowerCase().replace(/\s+/g, '-'),
      displayName: locationMatch.name,
      country: locationMatch.country
    };
  }

  // Partial match
  const partialMatch = WONDERNETWORK_LOCATIONS.find(
    loc => loc.name.toLowerCase().includes(searchTerm) ||
           loc.location.toLowerCase().includes(searchTerm)
  );

  if (partialMatch) {
    return {
      serverName: partialMatch.name.toLowerCase().replace(/\s+/g, '-'),
      displayName: partialMatch.name,
      country: partialMatch.country
    };
  }

  return null;
}
